import { Component, OnInit } from '@angular/core';
import { SessionService } from 'app/components/common/session/session.service';
import { CatalogueUserService } from 'app/components/catalogueUser/catalogue-user.service';
import { LoginService } from 'app/components/login/login.service';

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html',
  styleUrls: ['./change-password.component.css']
})
export class ChangePasswordComponent implements OnInit {

  loader: any = { count: 0 };
  alertType: string = '';
  alertMessage: string = '';
  passwordErrorMessage: string = '';

  isChanging: boolean = false;

  typePassword: Array<any> = ['password', 'password', 'password'];
  oldPassword: string = '';
  newPassword: string = '';
  repeatPassword: string = '';

  eventData: object = {};


  constructor(private sessionService: SessionService, private catalogueUserService: CatalogueUserService, private loginService: LoginService) { }

  togglePassword(position){
    this.typePassword[position] = this.typePassword[position] === 'password' ? 'text' : 'password';
  }

  disableForm() {

    this.passwordErrorMessage = '';

    if (!this.oldPassword || !this.newPassword || !this.repeatPassword) {
      return true;
    } else if (this.newPassword !== this.repeatPassword) {
      this.passwordErrorMessage = 'CHANGE_PASSWORD.PASSWORD_NOT_EQUAL';
      return true;
    } else if (this.newPassword.length < 8 || this.repeatPassword.length < 8) {
      this.passwordErrorMessage = 'CHANGE_PASSWORD.INVALID_PASSWORD';
      return true;
    } else {
      return false;
    }

  }

  passwordIsValid(pwd: string): boolean {
    if (pwd.match(/^(?=.*[a-z])(?=\S+$)(?=.*[A-Z])(?=.*[0-9]).{8,15}$/)) {
      this.passwordErrorMessage = '';
      return true;
    } else {
      this.passwordErrorMessage = 'CHANGE_PASSWORD.INVALID_PASSWORD';
      return false;
    }
  }



  changePassword(changePasswordIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.catalogueUserService.changePassword(changePasswordIn)
      .subscribe((data: object) => {
        this.changePasswordOk(data);
      },
        error => {
          this.changePasswordError(error);
        });

  }

  changePasswordOk(data) {

    this.loader.count--;
    let nameStorageUsername = `username_${this.eventData['sapCode']}`;

    let getTokenIn = {
      accountId: this.eventData['accountId'],
      username: JSON.parse(this.sessionService.get(nameStorageUsername,true)),
      password: this.newPassword
    }

    this.getToken(getTokenIn);

  }

  changePasswordError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.code
    }

    if (error.code == '000055') {
      alertData.alertMessage = 'CHANGE_PASSWORD.' + error.code;
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }

  changePasswordBtn() {

    let nameStorageUsername = `username_${this.eventData['sapCode']}`;

    let changePasswordIn = {
      accountId: this.eventData['accountId'],
      eventId: this.eventData['id'],
      newPassword: this.newPassword,
      oldPassword: this.oldPassword,
      username: JSON.parse(this.sessionService.get(nameStorageUsername,true))
    }

    this.changePassword(changePasswordIn);

  }

  getToken(getTokenIn) {

    this.loader.count++;
    this.alertType = '';
    this.alertMessage = '';

    this.loginService.getToken(getTokenIn)
      .subscribe((token: object) => {
        let data = {"token": token, "user":getTokenIn}
        this.getTokenOk(data);
      },
        error => {
          this.getTokenError(error);
        });

  }

  getTokenOk(data) {
    this.loader.count--;
    let nameStorageToken = `token_${this.eventData['sapCode']}`;
    this.sessionService.set(nameStorageToken, data.token, true);
  }

  getTokenError(error) {

    let alertData = {
      alertType: 'error',
      alertMessage: error.message
    }

    this.loader.count--;
    this.alertType = alertData.alertType;
    this.alertMessage = alertData.alertMessage;

  }


  ngOnInit() {
    this.eventData = JSON.parse(this.sessionService.get('eventData', false) || '{}');
  }

}
